import { render, staticRenderFns } from "./ReadyToShipButton.vue?vue&type=template&id=3738ff00"
import script from "./ReadyToShipButton.vue?vue&type=script&lang=js"
export * from "./ReadyToShipButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports